// Muted build-version label shown on the auth screens. The deploy pipeline
// bakes VITE_APP_VERSION (the ADO build number, e.g. "1.0.42") into each SPA
// bundle; local builds leave it unset, so we fall back to "dev". Centralised
// here so all three SPAs render the version identically.
export function AppVersion() {
  const version = import.meta.env.VITE_APP_VERSION ?? 'dev';
  return (
    <div className="text-[10px] uppercase tracking-[0.2em] text-slate-400">
      v{version}
    </div>
  );
}
